import { createForm } from '@leprecoins/effector-forms';
import { sample } from 'effector';
import { authModel, loginMutation } from 'shared/api';
import { maxLengthRule, minLengthRule, notEmptyRule } from 'shared/lib';
import { PASSWORD_MIN_LENGTH, USERNAME_MIN_LENGTH, PASSWORD_MAX_LENGTH } from '../config';

const form = createForm({
	fields: {
		username: {
			init: '',
			rules: [notEmptyRule, minLengthRule(USERNAME_MIN_LENGTH)],
		},
		password: {
			init: '',
			rules: [notEmptyRule, minLengthRule(PASSWORD_MIN_LENGTH), maxLengthRule(PASSWORD_MAX_LENGTH)],
		},
	},
	validateOn: ['submit'],
	resetErrorsOnChange: true,
});

const usernameField = form.fields.username;

const passwordField = form.fields.password;

sample({
	clock: form.submitted,
	source: form.$values,
	target: loginMutation.start,
});

sample({
	clock: loginMutation.finished.success,
	fn: ({ result }) => result,
	target: authModel.authorized,
});

export const loginPageModel = {
	form,
	usernameField,
	passwordField,
};
